export default "__VITE_ASSET__Bqgna2R2__"